import React from 'react';
import PropTypes from 'prop-types';

export default function Dashboard(props) {
  const { height, width, iconColor } = props;

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 16.964">
      <g transform="translate(-346.515 -280.222)">
        <g stroke={iconColor} fill="none" transform="translate(354.997 284.24) rotate(45)">
          <rect stroke="none" width="6.314" height="6.314" />
          <rect fill="none" x="0.5" y="0.5" width="5.314" height="5.314" />
        </g>
        <g stroke={iconColor} fill="none" transform="translate(363.033 284.239) rotate(45)">
          <rect stroke="none" width="6.314" height="6.314" />
          <rect fill="none" x="0.5" y="0.5" width="5.314" height="5.314" />
        </g>
        <g stroke={iconColor} fill="none" transform="translate(367.05 288.257) rotate(45)">
          <rect stroke="none" width="6.314" height="6.314" />
          <rect fill="none" x="0.5" y="0.5" width="5.314" height="5.314" />
        </g>
        <g stroke={iconColor} fill="none" transform="translate(350.979 288.257) rotate(45)">
          <rect stroke="none" width="6.314" height="6.314" />
          <rect fill="none" x="0.5" y="0.5" width="5.314" height="5.314" />
        </g>
        <g stroke={iconColor} fill="none" transform="translate(359.015 288.257) rotate(45)">
          <rect stroke="none" width="6.314" height="6.314" />
          <rect fill="none" x="0.5" y="0.5" width="5.314" height="5.314" />
        </g>
        <g stroke={iconColor} fill={iconColor} transform="translate(359.015 280.222) rotate(45)">
          <rect stroke="none" width="6.314" height="6.314" />
          <rect fill="none" x="1" y="1" width="4.314" height="4.314" />
        </g>
      </g>
    </svg>
  );
}

Dashboard.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string
};

Dashboard.defaultProps = {
  width: 22,
  height: undefined,
  iconColor: '#000'
};
